/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
function deselectValue(_ref) {
  var id = _ref.id,
    value = _ref.value,
    _ref$getIdProperty = _ref.getIdProperty,
    getIdProperty = _ref$getIdProperty === void 0 ? function (item) {
      return item && item.id;
    } : _ref$getIdProperty;
  var newValue;
  var singleValueId = (0, _typeof2.default)(value) === 'object' ? getIdProperty(value) : value;
  if (id === singleValueId || singleValueId === null) {
    newValue = null;
  }
  if (Array.isArray(value)) {
    newValue = value.filter(function (value) {
      var valueId = (0, _typeof2.default)(value) === 'object' ? getIdProperty(value) : value;
      return valueId !== id;
    });
    if (!newValue.length) {
      newValue = null;
    }
  }
  return newValue;
}
var _default = deselectValue;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/ComboBox/src/utils/deselectValue.js
// module id = 657
// module chunks = 0